import { state } from '../core/state.js';
import { socket } from '../core/socket.js';
import { demarrerE2EE } from '../core/e2ee.js';
import { appliquerTheme, changerVideoFond, chargerPreferencesServeur } from '../core/prefs.js';
import { updateDashboard, ouvrirAccueil } from '../ui/dashboard.js';
import { t, i18n } from '../core/i18n.js';
import { popToast } from '../utils/alerts.js';
import { chargerUserEmojis } from '../core/customEmojis.js';

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export function initSessionLifecycle() {
    
    // ─── 1. CONNEXION REUSSIE ───────────────────────────────────────────
    socket.on('connexion-success', (data) => {
        state.monPseudo = data.pseudo;
        state.maCouleur = data.couleur || data.couleur_preferee || '#ffb75e';
        
        // PONT DE SECOURS POUR APP.JS :
        window.monPseudo = data.pseudo;
        window.maCouleur = state.maCouleur;
        
        localStorage.setItem('monChatPseudo', data.pseudo);
        localStorage.setItem('chaos_token', data.token);
        localStorage.removeItem('monChatPass');

        const ecranAuth = document.getElementById('auth-screen');
        const ecranChat = document.getElementById('chat-screen');
        if (ecranAuth) ecranAuth.style.display = 'none';
        if (ecranChat) ecranChat.style.display = 'flex';

        // Protège l'IndexedDB (clés E2EE) contre l'éviction automatique du navigateur.
        if (navigator.storage && navigator.storage.persist) navigator.storage.persist();

        if (window._finBoot) window._finBoot();
        
        if (typeof window.naviguer === "function") {
            window.naviguer('dashboard'); 
        } else {
            ouvrirAccueil();
        }

        configurerAvatarProfil(data);

        if (document.getElementById('edit-bio')) document.getElementById('edit-bio').value = data.bio || '';
        if (document.getElementById('edit-color')) document.getElementById('edit-color').value = data.couleur_preferee || '#58a6ff';

        socket.emit('nouveau-utilisateur', data.pseudo);
        socket.emit('initialiser-notifications');
        socket.emit('spotify-status');
        socket.emit('demander-mes-spheres');
        socket.emit('moderation-demander-count');
        socket.emit('moderation-check-mute');
        socket.emit('moderation-demander-mon-role');

        window.dejaConnecte = true;
        demarrerE2EE(data);
        if (typeof window.consommerInviteEnAttente === 'function') window.consommerInviteEnAttente();
        chargerPreferencesServeur();
        chargerUserEmojis();
        if (typeof window.majUI2FA === 'function') window.majUI2FA(!!data.totp_enabled);
        if (data.totp_enabled) document.getElementById('modal-2fa-login').style.display = 'none';
    });

    // ─── 2. RECONNEXION AUTO ───────────────────────────────────────────
    socket.on('session-valide', (data) => {
        state.monPseudo = data.pseudo;
        state.maCouleur = data.couleur || data.couleur_preferee || '#ffb75e';
        
        // PONT DE SECOURS POUR APP.JS :
        window.monPseudo = data.pseudo;
        window.maCouleur = state.maCouleur;
        
        localStorage.setItem('monChatPseudo', data.pseudo);
        
        document.getElementById('auth-screen').style.display = 'none';
        document.getElementById('chat-screen').style.display = 'flex';
        if (navigator.storage && navigator.storage.persist) navigator.storage.persist();
        if (window._finBoot) window._finBoot();

        configurerAvatarProfil(data);

        if (document.getElementById('edit-bio')) document.getElementById('edit-bio').value = data.bio || '';
        if (document.getElementById('edit-color')) document.getElementById('edit-color').value = data.couleur || '#58a6ff';

        const sauvegarde = localStorage.getItem('derniereVue');
        let destination = sauvegarde ? JSON.parse(sauvegarde) : { vue: 'dashboard', data: {} };
        const vuesInterditesApresLogin = ['login', 'register', 'google-setup', 'verify'];
        if (vuesInterditesApresLogin.includes(destination.vue)) {
            destination = { vue: 'dashboard', data: {} };
        }
        
        if (typeof window.naviguer === 'function') window.naviguer(destination.vue, destination.data);

        socket.emit('demander-mes-spheres');
        window.enAttenteDeNavigation = true;
        socket.emit('demander-liste-maj');
        socket.emit('nouveau-utilisateur', data.pseudo);
        socket.emit('initialiser-notifications');
        socket.emit('spotify-status');
        socket.emit('moderation-demander-count');
        socket.emit('moderation-check-mute');
        socket.emit('moderation-demander-mon-role');
        
        window.dejaConnecte = true;
        demarrerE2EE(data);
        if (typeof window.consommerInviteEnAttente === 'function') window.consommerInviteEnAttente();
        chargerPreferencesServeur();
        chargerUserEmojis();
        if (typeof window.majUI2FA === 'function') window.majUI2FA(!!data.totp_enabled);

        const vocalId = localStorage.getItem('memoireVocalId');
        const vocalNom = localStorage.getItem('memoireVocalNom');
        if (vocalId && vocalNom && typeof window.rejoindreSalon === 'function') {
            setTimeout(() => { window.rejoindreSalon(vocalId, vocalNom, 'vocal'); }, 800);
        }

        const appelMP = localStorage.getItem('memoireAppelMP');
        if (appelMP && typeof window.demarrerAppelMP === 'function') {
            setTimeout(() => { window.demarrerAppelMP(appelMP, true); }, 800);
        }
    });

    // ─── 3. REJET DE LA SESSION ────────────────────────────────────────
    socket.on('session-invalide', () => {
        localStorage.removeItem('chaos_token');
        if (typeof window.naviguer === 'function') window.naviguer('login');
        if (window._finBoot) window._finBoot();
    });
}

function configurerAvatarProfil(data) {
    const selfAvatar = document.getElementById('self-avatar');
    const selfInitiale = document.getElementById('self-avatar-initiale');
    if (!selfAvatar) return;

    if (data.avatar_url && data.avatar_url !== 'none') {
        selfAvatar.style.background = `url('${data.avatar_url}') center/cover no-repeat`;
        if (selfInitiale) selfInitiale.style.display = 'none';
    } else {
        selfAvatar.style.background = data.couleur_preferee || '#58a6ff';
        if (selfInitiale) {
            selfInitiale.textContent = data.pseudo.charAt(0).toUpperCase();
            selfInitiale.style.display = 'block';
        }
    }
}

// ─── 4. LE BOOT INITIAL ────────────────────────────────────────────────
export async function initAppBoot() {
    const localeSauvegardee = localStorage.getItem('chaos_locale') || 'fr';
    await i18n.load(localeSauvegardee);

    const themeSauvegarde = localStorage.getItem('chaos_theme_color');
    if (themeSauvegarde) appliquerTheme(themeSauvegarde);

    const btnSupp = document.getElementById('btn-suppression');
    if (btnSupp && window.rtcState) {
        btnSupp.classList.toggle('active-suppression', window.rtcState.suppressionActive);
        btnSupp.title = t(window.rtcState.suppressionActive ? 'nav.suppression_on' : 'nav.suppression_off');
    }
    
    const videoSauvegardee = localStorage.getItem('chaos_bg_video');
    if (videoSauvegardee) {
        const selectEl = document.getElementById('bg-video-select');
        if (selectEl) selectEl.value = videoSauvegardee;
        if (!localStorage.getItem('chaos_bg_custom')) changerVideoFond(videoSauvegardee);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const verifiedStatus = urlParams.get('verified');
    
    if (verifiedStatus) {
        history.replaceState({}, '', window.location.pathname + window.location.hash);
        const errorP = document.getElementById('auth-error');
        if (verifiedStatus === 'success') {
            if (errorP) { errorP.style.color = '#3fb950'; errorP.textContent = t('auth.verify.success'); }
            const loginPseudo = document.getElementById('login-pseudo');
            if (loginPseudo && urlParams.get('pseudo')) loginPseudo.value = urlParams.get('pseudo');
            if (typeof window.naviguer === 'function') window.naviguer('login');
        } else if (errorP) {
            errorP.style.color = '#f85149';
            errorP.textContent = t(`auth.verify.${verifiedStatus}`) || t('auth.verify.error');
            if (typeof window.naviguer === 'function') window.naviguer('login');
        }
        return;
    }

    const oauthToken = urlParams.get('oauth_token');
    const oauthPending = urlParams.get('oauth_pending');
    const oauthSetup = urlParams.get('oauth_setup');
    const oauthErr = urlParams.get('oauth');

    if (oauthToken) {
        history.replaceState({}, '', window.location.pathname + window.location.hash);
        localStorage.setItem('chaos_token', oauthToken);
    } else if (oauthSetup) {
        history.replaceState({}, '', window.location.pathname + window.location.hash);
        window._googleSetupToken = oauthSetup;
        if (typeof window.naviguer === 'function') window.naviguer('google-setup');
        setTimeout(() => { document.getElementById('google-setup-pseudo')?.focus(); }, 100);
        return;
    } else if (oauthPending) {
        history.replaceState({}, '', window.location.pathname + window.location.hash);
        window._pending2faToken = oauthPending;
        if (typeof window.naviguer === 'function') window.naviguer('login');
        setTimeout(() => {
            document.getElementById('modal-2fa-login').style.display = 'flex';
            document.getElementById('input-2fa-login').value = '';
            document.getElementById('input-2fa-login')?.focus();
        }, 100);
        return;
    } else if (oauthErr) {
        history.replaceState({}, '', window.location.pathname + window.location.hash);
        const errorP = document.getElementById('auth-error');
        if (errorP) { errorP.style.color = '#f85149'; errorP.textContent = t('auth.oauth_error') || 'Connexion Google échouée.'; }
        if (typeof window.naviguer === 'function') window.naviguer('login');
        return;
    }

    const savedToken = localStorage.getItem('chaos_token');
    const sessionActive = getCookie('chaos_session_active');
    const fullHash = window.location.hash.replace('#', '');
    const parts = fullHash.split('/');

    if (savedToken) {
        if (!sessionActive) {
            document.cookie = "chaos_session_active=true; path=/; SameSite=Lax";
            window.destinationApresChargement = { vue: 'dashboard', data: {} };
        } else if (parts[0] === 'sphere' && parts[1]) {
            window.destinationApresChargement = { vue: 'sphere', data: { id: parts[1] } };
        } else if (parts[0] === 'mp' && parts[1]) {
            const sauvegarde = localStorage.getItem('derniereVue');
            const dataSauves = sauvegarde ? JSON.parse(sauvegarde).data : {};
            window.destinationApresChargement = { vue: 'mp', data: { id: parts[1], pseudo: dataSauves.pseudo } };
        } else {
            const sauvegarde = localStorage.getItem('derniereVue');
            window.destinationApresChargement = sauvegarde ? JSON.parse(sauvegarde) : { vue: 'dashboard', data: {} };
        }
        socket.emit('valider-session', savedToken);
    } else {
        if (typeof window.naviguer === 'function') window.naviguer('login');
        if (window._finBoot) window._finBoot();
    }
}